import Preact from 'preact'

import * as previewStyles from '../../Preview/index.css'
import * as styles from './index.css'
import { Clips } from '../../../../../../types'
import {
  scrollIntoView,
  scrollADistance
} from '../../../../../../lib/scroll-into-view/scroll-into-view'
import { bem } from '@nrk/dh-utils'
import { ClipsPreview } from '../../Preview/ClipsPreview'
import { shallowEqual } from '../../../../../../lib/shallow-equal'
import throttle from 'lodash.throttle'

const { h, Component } = Preact

interface IProps {
  showLikes: boolean
  showViews: boolean
  items: Clips
  currentIndex: number
  onClick: (...args: any[]) => void
}

interface IState {
  isInitial: boolean
  canScrollRight: boolean
  canScrollLeft: boolean
}

class ClipsNav extends Component<IProps, IState> {
  public previewRefs: { [key: string]: HTMLElement } | null = {}
  public containerRef: HTMLElement | undefined | null
  public scrollListener = null

  constructor(props) {
    super(props)
    this.state = {
      isInitial: true,
      canScrollRight: true,
      canScrollLeft: false
    }
  }

  public componentDidMount() {
    this.scrollListener = throttle(this.handleScroll, 16.666)
    this.containerRef.addEventListener('scroll', this.scrollListener)
  }

  public componentWillUnmount() {
    this.previewRefs = {}
    this.containerRef.removeEventListener('scroll', this.scrollListener)
    this.containerRef = null
  }
  public shouldComponentUpdate(props, state) {
    return !(shallowEqual(props, this.props) && shallowEqual(state, this.state))
  }

  public componentDidUpdate(prevProps: IProps) {
    if (
      this.state.isInitial ||
      this.props.currentIndex !== prevProps.currentIndex
    ) {
      this.scrollIntoView(this.props.currentIndex, true)
    }
  }

  public handleScroll = () => {
    const { scrollLeft, scrollWidth } = this.containerRef
    const { width } = this.containerRef.getBoundingClientRect()

    const canScrollLeft = scrollLeft > 10
    const canScrollRight = scrollLeft + width + 10 < scrollWidth
    const currentCanScrollLeft = this.state.canScrollLeft
    const currentCanScrollRight = this.state.canScrollRight
    if (
      canScrollLeft !== currentCanScrollLeft ||
      canScrollRight !== currentCanScrollRight
    ) {
      this.setState({ canScrollLeft, canScrollRight })
    }
  }

  public scrollIntoView = (idx: number, smooth: boolean = true) => {
    const item = this.props.items[idx]
    if (
      this.previewRefs &&
      Object.keys(this.previewRefs).length &&
      this.containerRef
    ) {
      let currentRef = null
      if (!item) {
        const firstMatchRef = this.props.items[0].id
        currentRef = this.previewRefs[firstMatchRef]
      } else {
        currentRef = this.previewRefs[item.id]
      }
      if (!currentRef) return

      const duration = this.state.isInitial ? 0 : 250

      scrollIntoView(currentRef, this.containerRef, { duration })

      if (this.state.isInitial) {
        this.setState({ isInitial: false })
      }
    }
  }

  public handleScrollClick = (direction: 'right' | 'left') => () => {
    const res = scrollADistance(this.containerRef, null, { direction })
    this.setState({ ...res })
  }

  public render({}) {
    const { items, currentIndex, onClick, showLikes, showViews } = this.props
    const { canScrollLeft, canScrollRight } = this.state

    return (
      <div
        class={bem(styles['clip-nav'], {
          'right-end': !canScrollRight,
          'left-end': !canScrollLeft
        })}
      >
        <ul
          ref={el => (this.containerRef = el)}
          class={styles['clip-nav__wrapper']}
        >
          {items &&
            items.filter(Boolean).map((item, idx) => (
              <li
                ref={el => (this.previewRefs[item.id] = el)}
                class={bem(styles['clip-nav__item'], {
                  active: idx === currentIndex,
                  passed: idx < currentIndex,
                  next: idx === currentIndex + 1
                })}
                key={item.id}
                onClick={() => onClick(idx)}
              >
                <div class={bem(previewStyles['preview-item'], 'clip')}>
                  <ClipsPreview
                    clip={item}
                    showLikes={showLikes}
                    showViews={showViews}
                  />
                </div>
              </li>
            ))}
        </ul>
        <div class={bem(styles['clip-nav__control'], 'prev')}>
          <button
            disabled={!canScrollLeft}
            onClick={this.handleScrollClick('left')}
            aria-hidden="true"
          >
            <span>
              <svg aria-hidden="true">
                <use xlinkHref="#nrk-chevron-left" />
              </svg>
            </span>
          </button>
        </div>
        <div class={bem(styles['clip-nav__control'], 'next')}>
          <button
            disabled={!canScrollRight}
            onClick={this.handleScrollClick('right')}
            aria-hidden="true"
          >
            <span>
              <svg aria-hidden="true">
                <use xlinkHref="#nrk-chevron-right" />
              </svg>
            </span>
          </button>
        </div>
      </div>
    )
  }
}

export { ClipsNav }
